// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"style_subtitleContainer__WNCZV","hint":"style_hint__+DpTN"};